import { setDashboardNeedsRefresh } from '../redux/actions/dashboardActions';
import { REALTIME_EVENT_TYPES } from './types';
import {
  OPEN_KNOTS_BID_LIFECYCLE_EVENTS,
  findOpenKnotsBidAwardNotification,
  findOpenKnotsRfqExpiryNotification,
  getOpenKnotsBidLifecycleToast,
  getOpenKnotsToastFromNotificationRecord,
  isOpenKnotsRfqExpiryNotificationPayload,
} from './openKnotsBidLifecycle';
import { showOpenKnotsLifecycleToast } from './openKnotsToast';
import {
  refreshNotificationCenter,
  shouldShowGenericCountToastForNotificationCreated,
} from './notificationCenterRefresh';
import { getEnvelopeRfqUlid } from './types';

/**
 * Wire store-bound handlers for notification + dashboard signals.
 * @param {import('@reduxjs/toolkit').Store} store
 * @param {(eventType: string|string[], handler: Function) => () => void} subscribe
 */
export function bindRealtimeStoreHandlers(store, subscribe) {
  const unsubscribers = [];

  unsubscribers.push(
    subscribe(REALTIME_EVENT_TYPES.NOTIFICATION_CREATED, async (envelope) => {
      const selectedBuyer = localStorage.getItem('associatedBroker');
      const showGeneric = shouldShowGenericCountToastForNotificationCreated(envelope.payload);
      const notifResult = await refreshNotificationCenter(store, {
        selectedBuyer,
        showGenericCountToast: showGeneric,
      });

      const notifications = notifResult?.payload?.notifications || [];
      if (isOpenKnotsRfqExpiryNotificationPayload(envelope.payload)) {
        const row = findOpenKnotsRfqExpiryNotification(notifications, getEnvelopeRfqUlid(envelope));
        const rowToast = getOpenKnotsToastFromNotificationRecord(row);
        if (rowToast) {
          showOpenKnotsLifecycleToast(rowToast, envelope);
        }
      }
      const newDealFinancing = notifications.find((n) => n.payload && n.payload.event === 'Deal Financing');
      if (newDealFinancing || envelope.payload?.eventName === 'Deal Financing') {
        store.dispatch(setDashboardNeedsRefresh(true));
      }
    })
  );

  unsubscribers.push(
    subscribe(
      [REALTIME_EVENT_TYPES.FACILITY_BALANCE_CHANGED, REALTIME_EVENT_TYPES.DASHBOARD_UPDATED, REALTIME_EVENT_TYPES.FACILITY_UPDATED],
      () => {
        store.dispatch(setDashboardNeedsRefresh(true));
      }
    )
  );

  unsubscribers.push(
    subscribe(OPEN_KNOTS_BID_LIFECYCLE_EVENTS, async (envelope) => {
      if (envelope?.eventType === REALTIME_EVENT_TYPES.RFQ_BID_ACCEPTED) {
        const notifResult = await refreshNotificationCenter(store, { showGenericCountToast: false });
        const notifications = notifResult?.payload?.notifications || [];
        const row = findOpenKnotsBidAwardNotification(notifications, getEnvelopeRfqUlid(envelope));
        const rowToast = getOpenKnotsToastFromNotificationRecord(row);
        if (rowToast) {
          showOpenKnotsLifecycleToast(rowToast, envelope);
          return;
        }
      }
      showOpenKnotsLifecycleToast(getOpenKnotsBidLifecycleToast(envelope), envelope);
      if (envelope?.eventType !== REALTIME_EVENT_TYPES.RFQ_BID_ACCEPTED) {
        await refreshNotificationCenter(store, { showGenericCountToast: false });
      }
    })
  );

  return () => unsubscribers.forEach((u) => u());
}
